 define('modules/editor/views/edit_popup_header',['require','exports','module','base/collectionview','underscore','backbone','base/itemview','ldsh!../templates/edit_element_popup_tab','ldsh!../templates/edit_element_popup_header'],function(require, exports, module) {
   "use strict";

   var CollectionView = require("base/collectionview"),
       _ = require("underscore"),
       Backbone = require("backbone"),
       ItemView = require("base/itemview");

   var TabView = ItemView.extend({
     initialize: function() {
       this.viewModel = new Backbone.Model({
         iname: this.model.name.replace(/:/g, "_")
       });

     },
     triggers: { "click a.js-tab-switch": "selected" },
     template: require("ldsh!../templates/edit_element_popup_tab"),
     tagName: "li",
     className: "ed-single-tab",
     onRender: function() {
       this.$el.i18n();
     },
   });

   module.exports = CollectionView.extend({
     template: require("ldsh!../templates/edit_element_popup_header"),
     itemContainer: "ul",
     itemView: TabView,

     initialize: function() {
       this.childVent.on("selected", this.onSelected, this);
     },

     collectionIterator: _.each,

     select: function(i) {
       this.$(".active").removeClass("active");
       this._childViews[i].$el.addClass("active");
     },

     onSelected: function(childView) {
       var i = _.indexOf(this._childViews, childView);
       this.select(i);
       this.trigger("selected", i);
     },

     onRender: function() {
       this.$el.i18n();
     }
   });

 });

